$(".table-links").on("click", "tr", function(e) {
    if ($(e.target).is("a,input")) // anything else you don't want to trigger the click
    return;
    location.href = $(this).find("a").attr("href");
});

$(".table-links tr td").has('a').parents('tr').addClass('hasLink');